export function initializeToast(root) {
	const handleToast = (event) => {
		const toastLink = event.target.closest?.('[data-toggle="toast"]');
		if (!toastLink || !root.contains(toastLink)) return;

		event.preventDefault();
		const toast = root.querySelector(toastLink.getAttribute('data-target'));
		if (toast && window.bootstrap?.Toast) {
			window.bootstrap.Toast.getOrCreateInstance(toast).show();
		}
	};

	root.addEventListener('click', handleToast);

	return () => root.removeEventListener('click', handleToast);
}
